module.exports = __webpack_public_path__ + "img/24.b644ac07.webp";